"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _times = _interopRequireDefault(require("lodash/times"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const PulseLoader = ({
  className,
  size,
  borderWidth,
  additionalMarkup
}) => {
  const classes = (0, _classnames.default)('PulseLoader', className);
  const borderWidthx4 = borderWidth * 4;
  const numInnerRings = size / borderWidthx4 - 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "PulseLoader-pulse",
    style: {
      width: size,
      height: size
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "PulseLoader-pulse-outer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "PulseLoader-pulse-ring",
    style: {
      borderWidth
    }
  })), (0, _times.default)(numInnerRings, i => {
    const newSize = size - borderWidthx4 * (i + 1);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: "PulseLoader-pulse-inner",
      style: {
        width: newSize,
        height: newSize
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "PulseLoader-pulse-ring",
      style: {
        borderWidth
      }
    }));
  })), additionalMarkup);
};
PulseLoader.defaultProps = {
  size: 120,
  borderWidth: 7
};
var _default = exports.default = PulseLoader;